import clsx from "clsx";
import copy from "copy-to-clipboard";
import { useToasts } from "react-toast-notifications";

import { GenericTooltip } from "@components/tooltip-container";
import { useUser } from "@components/user-context";

interface Props {
  rowId: string;
  name: string;
  showFlyoutOption: boolean;
  onOpenFlyout: () => void;
}

export const HoverStateOptions = ({
  rowId,
  name,
  showFlyoutOption,
  onOpenFlyout,
}: Props) => {
  const { user } = useUser();
  const { addToast } = useToasts();

  return (
    <div className="absolute right-0 text-sm h-full hidden group-hover:block">
      <div className="h-full px-2 flex items-center gap-2">
        {user.isAdmin && (
          <GenericTooltip
            content="Copy Ad Key"
            noInfoCircle
            overlayClassName="pointer-events-none"
            placement="top"
            mouseEnterDelay={1000}
          >
            <i
              className={clsx(
                "bg-white elevation-1 rounded-full p-[5px] fa-sharp fa-solid fa-rectangle-ad",
                "cursor-pointer text-md text-primary font-light",
              )}
              onClick={() => {
                addToast("COPIED AD KEY TO CLIPBOARD", {
                  appearance: "success",
                });
                copy(rowId);
              }}
            ></i>
          </GenericTooltip>
        )}
        {showFlyoutOption && (
          <GenericTooltip
            content="Open flyout"
            noInfoCircle
            overlayClassName="pointer-events-none"
            placement="top"
            mouseEnterDelay={1000}
          >
            <span
              className={clsx(
                "bg-white elevation-1 rounded-full cursor-pointer text-primary",
                "font-semibold h-6 px-2.5 text-xs flex items-center",
              )}
              onClick={() => onOpenFlyout()}
            >
              <i className="fa-sharp fa-solid fa-sidebar-flip font-light mr-1"></i>
              OPEN
            </span>
          </GenericTooltip>
        )}
        <GenericTooltip
          content="Copy"
          noInfoCircle
          overlayClassName="pointer-events-none"
          placement="top"
          mouseEnterDelay={1000}
        >
          <i
            className={clsx(
              "bg-white elevation-1 rounded-full p-[5px] fa-sharp fa-solid fa-clone",
              "cursor-pointer text-md text-primary font-light",
            )}
            onClick={() => {
              addToast("COPIED NAME TO CLIPBOARD", { appearance: "success" });
              copy(name);
            }}
          ></i>
        </GenericTooltip>
      </div>
    </div>
  );
};
